import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientAllocationActions, IThunkAddClientAllocation } from '../types';

const onAddOwnClientAllocation: IThunkAddClientAllocation = thunk(
  async (_actions: Actions<IClientAllocationActions>, { clinicId, teamId, payload }) => {
    await api.clientAllocation.addOwnClientAllocation(
      { clinicId, teamId },
      {
        clients: payload.allocations[0].clients,
        locationGroupIds: payload.allocations[0].locationGroupIds,
        from: payload.from,
        to: payload.to,
        includeWeekends: payload.includeWeekends,
      },
    );
  },
);

export default onAddOwnClientAllocation;
